import type { UsersFilterState } from '../../../types/dashboardV2';
import type { MobileUsersFilterState } from '../../../types/mobileFilterSheetTypes';

/**
 * The sheet's date-range chips have no "Any" option, so the page's
 * empty ('' = any) value maps to the sheet default and back.
 */
const SHEET_DEFAULT_DATE_RANGE = 'Last 30 days';

/** Page filters -> mobile-sheet draft (drops `search`; '' -> null). */
export const toMobileUsersFilters = (
  filters: UsersFilterState,
): MobileUsersFilterState => ({
  role: filters.role || null,
  status: filters.status || null,
  dateRange: filters.dateRange || SHEET_DEFAULT_DATE_RANGE,
  hasActiveSession: filters.hasActiveSession,
  hasTelegram: filters.hasTelegram,
});

/** Mobile-sheet draft -> page filter updates (null -> ''). */
export const fromMobileUsersFilters = (
  mobile: MobileUsersFilterState,
): Partial<UsersFilterState> => ({
  role: mobile.role ?? '',
  status: mobile.status ?? '',
  dateRange: mobile.dateRange === SHEET_DEFAULT_DATE_RANGE ? '' : mobile.dateRange,
  hasActiveSession: mobile.hasActiveSession,
  hasTelegram: mobile.hasTelegram,
});
